import React from 'react';
import { useSelector } from 'react-redux';
import { Container, DivLink, Text } from './Styles';

export default function CookiesMessage() {
  const politicaPrivacidade = useSelector(
    (state: ApplicationState) => state.config.politicaPrivacidade
  );

  if (politicaPrivacidade === '') return <></>;

  return (
    <Container>
      <Text>
        Ao realizar a busca, eu declaro que li e estou de acordo com a{' '}
        <DivLink to='/privacy-terms'>
          Política de Privacidade e Termos de Uso
        </DivLink>
        .
      </Text>
    </Container>
  );
}
